import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {DrugIngredientDTO} from './DrugIngredientDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class MasterDrugDTO extends BaseDTO {
  masterDrugId: number;
  name: string;
  dosageForm: NameValueDTO;

  startDate: Date;
  endDate: Date;

  routesOfAdmin: NameValueDTO[];
  ingredients: DrugIngredientDTO[];
  atcCodes: MasterDrugAtcDTO[];
}

export class MasterDrugAtcDTO {
  atcId: number;
  name: string;
  ingredients: NameValueDTO[];
}
